
<div class="col-lg-12 nopadding">
  @if(isLoadingResults){
  <div class="example-loading-shade">
    <mat-spinner></mat-spinner>
  </div>
  }
  
  <div class="carousel carousel-showmanymoveone slide" id="carousel-tilenav" data-interval="false">
    <div class="carousel-inner">
        <div class="panel panel-default nopadding">
           <app-stat-box [orderCategary] ="orderCategary" [RouteCategary]="RouteCategary" [displayDivider]="displayDivider"
          [defaultFilters] ="DefaultFilterArray">
          </app-stat-box>
            <div class="panel-heading">
                <p class="panel-title"><b>Orders Summary Section
                    </b></p>
            </div>
            <div class="panel-body nopadding">
                <div class="col-md-12" class="text-left p-l-6">
            <strong [ngClass]="displayDivider ? {'smallFont':false} : {'smallFont':true}">Total orders and top 25 customer’s:</strong>
            </div>
                <div class="ui-fluid">
                    <p-scrollPanel styleClass="customScroll">
                        <div class="ui-g">
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'greenBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Orders','')">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>Total</span></li>
                                                <li class="smallFont"><span>{{orderSummaryDetails?.numberOfOrders}}</span></li>
                                                <li class="smallFont"><span>{{orderSummaryDetails?.totalShares | number}}</span></li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            @for(item of topCustomers; track item + '-'+ $index){
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'blueBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Orders',item?.customers)">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>{{item?.customers}}</span></li>
                                                <li class="smallFont"><span>{{item?.orders}}</span></li>
                                                <li class="smallFont"><span>{{item?.shares | number}}</span></li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            }
                        </div>
                    </p-scrollPanel>
                </div>
            </div>
            <div class="panel-heading">
                <p class="panel-title"><b>Routes Summary Section
                    </b></p>
            </div>
            <div class="panel-body nopadding">
                <div class="col-md-12" class="text-left p-l-6">
            <strong [ngClass]="displayDivider ? {'smallFont':false} : {'smallFont':true}">Total routes and venue:</strong>
            </div>
                <div class="ui-fluid">
                    <p-scrollPanel styleClass="customScroll">
                        <div class="ui-g">
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'greenBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Routes','')">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>Total</span></li>
                                                <li class="smallFont"><span>{{routeSummaryDetails?.numberOfRoutes}}</span></li>
                                                <li class="smallFont"><span>{{routeSummaryDetails?.totalShares | number}}</span></li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            @for(item of venueName; track item + '-'+ $index){
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'blueBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Routes',item?.venueName)">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>{{item?.venueName}}</span></li>
                                                <li class="smallFont"><span>{{item?.routes}}</span></li>
                                                <li class="smallFont"><span>{{item?.shares | number}}</span></li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            }
                        </div>
                    </p-scrollPanel>
                </div>
            </div>
            <div class="panel-heading">
                <p class="panel-title"><b>Executions Summary Section
                    </b></p>
            </div>
            <div class="panel-body nopadding">
                 <div class="panel-body nopadding">
                <div class="col-md-12" class="text-left p-l-6">
            <strong [ngClass]="displayDivider ? {'smallFont':false} : {'smallFont':true}">Total executions and executing broker:</strong>
            </div>
                <div class="ui-fluid">
                    <p-scrollPanel styleClass="customScroll">
                        <div class="ui-g">
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'greenBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Executions','')">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>Total</span></li>
                                                <li class="smallFont"><span>{{executionSummaryDetails?.numberOfexecutions}}</span></li>
                                                <li class="smallFont"><span>{{executionSummaryDetails?.totalShares | number}}</span>
                                                </li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            @for(item of brokers; track item + '-'+ $index){
                            <div class="customBox text-center">
                                <div [ngClass]="displayDivider ? 'greenBoxSmall' : 'blueBox'">
                                    <span>
                                        <a class="disabled-link" (click)="openTransactionScreen('Executions',item?.execBroker)">
                                            <ul class="greenBoxList">
                                                <li class="smallFont"><span>{{item?.execBroker}}</span></li>
                                                <li class="smallFont"><span>{{item?.executions}}</span></li>
                                                <li class="smallFont"><span>{{item?.shares |number}}</span></li>
                                            </ul>
                                        </a>
                                    </span>
                                </div>
                            </div>
                            }
                        </div>
                    </p-scrollPanel>
                </div>
            </div>
        </div>